import { Component, OnInit, ViewChild, Renderer, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { AccessControlService } from 'src/app/services/access-control.service';
import { AlertService } from 'src/app/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { Action } from 'src/app/model/action.modals';
// declare var $: any;

@Component({
  selector: 'app-section-action-listing',
  templateUrl: './section-action-listing.component.html',
  styleUrls: ['./section-action-listing.component.css']
})
export class SectionActionListingComponent implements OnInit {
  modalRef: BsModalRef;
  @ViewChild('addsectionactionForm') public addsectionactionForm: NgForm;
  @ViewChild('tagForm') public tagForm: NgForm;
  model: Action;
  id: any
  section_id: any;
  app_id: any;
  application_name: any
  actionList: Array<Action> = [];
  app_name: any;
  is_tag: boolean = false;
  buttonTitle: any
  sectionActionId: any;
  module_id: any;
  application: any = [];
  constructor(private accesscontrolService: AccessControlService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer,
    private modalService: BsModalService) {
    this.activatedRoute.params.subscribe(params => {
      this.section_id = params['id'];
      this.app_id = params['app_id'];
    })
  }
  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
    //  this.modalRef = this.modalService.show(template);
  }
  openSupportingActionModal(supporting_action: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(supporting_action, config);
    //  this.modalRef = this.modalService.show(template);
  }
  back() {

  }

  ngOnInit() {
    this.buttonTitle = 'Add'
    this.getActionBySectionId()
  }

  getActionBySectionId() {
    this.accesscontrolService.getActionBySectionId(this.section_id, this.app_id, this.module_id).subscribe((res) => {
      this.actionList = res[0].section[0].section_action;

    }, error => {
      console.log(error)
    },
      () => { })
  }

  addAction(supporting_action: TemplateRef<any>) {
    this.model = new Action();
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(supporting_action, config);
  }
}

